import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ThreeButtonDialog } from '../models/three-button-dialog.model';

@Injectable({
    providedIn: 'root'
})
export class ThreeButtonDialogService {

    dialogRequested = new Subject<ThreeButtonDialog>();

    private resolver!: (value: string) => void;

    open(dialog: ThreeButtonDialog): Promise<string> {

        this.dialogRequested.next(dialog);

        return new Promise(resolve => {

            this.resolver = resolve;

        });

    }

    close(result: string) {

        this.resolver(result);

    }

}